import type { LocaleDefinition, LocaleNoParams } from '@gov-nx/core/types';
import { ServiceCode } from '../definitions/codes';
import { useLocale } from '@gov-nx/core/service';

export type PPPLocales = {
	seznam: {
		stav: {
			chyba: {
				'zadny-ppp': LocaleNoParams;
				'zadny-ppp-popis': LocaleNoParams;
				'prisny-filter': LocaleNoParams;
				'prisny-filter-popis': LocaleNoParams;
			};
		};
		nadpis: LocaleNoParams;
		sluzby: {
			nadpis: LocaleNoParams;
			popis: LocaleNoParams;
			zapis: {
				nadpis: LocaleNoParams;
				popis: LocaleNoParams;
			};
			filtr: {
				aktualni: LocaleNoParams;
				neplatne: LocaleNoParams;
				vse: LocaleNoParams;
				prijato: LocaleNoParams;
				schvaleno: LocaleNoParams;
				odeslano_k_dopracovani: LocaleNoParams;
				odeslano_spravci: LocaleNoParams;
				zamitnuto: LocaleNoParams;
				ukonceno: LocaleNoParams;
				params: {
					label: {
						datumOd: LocaleNoParams;
						datumDo: LocaleNoParams;
					};
				};
			};
			formular: {
				search: {
					placeholder: LocaleNoParams;
					wcag: {
						placeholder: LocaleNoParams;
						label: LocaleNoParams;
					};
				};
				modal: {
					label: {
						aktualni: LocaleNoParams;
						historie: LocaleNoParams;
					};
					description: {
						aktualni: LocaleNoParams;
						historie: LocaleNoParams;
					};
					datumOd: {
						label: LocaleNoParams;
						placeholder: LocaleNoParams;
					};
					datumDo: {
						label: LocaleNoParams;
					};
					button: {
						wgac: {
							open: LocaleNoParams;
							submit: LocaleNoParams;
						};
						submit: {
							text: LocaleNoParams;
							wgac: LocaleNoParams;
						};
						reset: {
							text: LocaleNoParams;
							wgac: LocaleNoParams;
						};
					};
				};
			};
		};
		item: {
			subjekt: LocaleNoParams;
			ovm: LocaleNoParams;
			datumPodani: LocaleNoParams;
			status: {
				PRIJATO: LocaleNoParams;
				ODESLANO_K_DOPRACOVANI: LocaleNoParams;
				ODESLANO_SPRAVCI: LocaleNoParams;
				ZAMITNUTO: LocaleNoParams;
				SCHVALENO: LocaleNoParams;
				UKONCENO: LocaleNoParams;
			};
		};
		button: {
			reklamace: {
				text: LocaleNoParams;
			};
		};
	};
	detail: {
		zadost: {
			nadpis: LocaleNoParams;
			'duvod-zamitnuti': {
				label: LocaleNoParams;
				nezadan: LocaleNoParams;
			};
			'id-zadosti': LocaleNoParams;
			'zakladni-udaje': {
				label: LocaleNoParams;
				'datum-podani': LocaleNoParams;
				'id-zadosti': LocaleNoParams;
			};
			zadatel: {
				label: LocaleNoParams;
				'jmeno-prijmeni': LocaleNoParams;
				'datum-narozeni': LocaleNoParams;
				'adresa-trvaleho-bydliste': LocaleNoParams;
			};
			prijemce: {
				label: LocaleNoParams;
				nazev: LocaleNoParams;
				'odpovedny-utvar': LocaleNoParams;
				'specifikace-utvaru': LocaleNoParams;
			};
			'detail-zadosti': {
				label: LocaleNoParams;
				'typ-PPP': LocaleNoParams;
				OVM: LocaleNoParams;
				'vydany-dokument': {
					label: LocaleNoParams;
					cislo: LocaleNoParams;
					'datum-vydani': LocaleNoParams;
					'datum-platnosti-od-do': LocaleNoParams;
				};
			};
			buttons: {
				reklamace: {
					text: LocaleNoParams;
					aria: LocaleNoParams;
				};
				ukoncit: {
					text: LocaleNoParams;
					aria: LocaleNoParams;
				};
			};
			prilohy: {
				stahnout: LocaleNoParams;
			};
			chip: {
				stav: {
					PRIJATO: LocaleNoParams;
					ODESLANO_K_DOPRACOVANI: LocaleNoParams;
					ODESLANO_SPRAVCI: LocaleNoParams;
					ZAMITNUTO: LocaleNoParams;
					SCHVALENO: LocaleNoParams;
					UKONCENO: LocaleNoParams;
				};
			};
		};
	};
	reklamace: {
		'hlavni-nadpis': {
			zapsana: LocaleNoParams;
			nezapsana: LocaleNoParams;
		};
		info: {
			zapsana: LocaleNoParams;
			nezapsana: LocaleNoParams;
		};
		'wgac-labels': {
			'kontaktni-udaje': {
				email: {
					edit: LocaleNoParams;
					cancel: LocaleNoParams;
				};
				phone: {
					edit: LocaleNoParams;
					cancel: LocaleNoParams;
				};
			};
		};
		form: {
			identificator: {
				label: LocaleNoParams;
				placeholder: LocaleNoParams;
			};
			complaintDescription: {
				label: LocaleNoParams;
				placeholder: LocaleNoParams;
			};
			complaintReason: {
				label: LocaleNoParams;
				placeholder: LocaleNoParams;
			};
			email: {
				label: LocaleNoParams;
				placeholder: LocaleNoParams;
			};
			phone: {
				label: LocaleNoParams;
				placeholder: LocaleNoParams;
			};
			button: {
				submit: {
					text: LocaleNoParams;
				};
				backToDetail: {
					text: LocaleNoParams;
				};
			};
			toast: {
				success: LocaleNoParams;
			};
			contacts: {
				description: LocaleNoParams;
			};
		};
		table: {
			nazev: LocaleNoParams;
			'datum-podani': LocaleNoParams;
			'id-zadosti': LocaleNoParams;
			'zastupovana-osoba': {
				description: LocaleNoParams;
				jmeno: LocaleNoParams;
				prijmeni: LocaleNoParams;
				'datum-narozeni': LocaleNoParams;
				adresa: LocaleNoParams;
			};
		};
	};
	ukonceni: {
		nadpis: LocaleNoParams;
		table: {
			nazev: LocaleNoParams;
			'datum-podani': LocaleNoParams;
			'id-zadosti': LocaleNoParams;
		};
		button: {
			backToDetail: {
				text: LocaleNoParams;
			};
			terminate: {
				text: LocaleNoParams;
			};
		};
		message: {
			warning: {
				text: LocaleNoParams;
			};
			ukonceno: LocaleNoParams;
		};
		warning: {
			lowLoa: LocaleNoParams;
		};
	};
	zapis: {
		form: {
			message: {
				odeslano: LocaleNoParams;
			};
			warning: {
				lowLoa: LocaleNoParams;
			};
			step1: {
				label: LocaleNoParams;
				kontaktniUdaje: {
					useEmail: { label: LocaleNoParams };
					usePhone: { label: LocaleNoParams };
					email: { label: LocaleNoParams; placeholder: LocaleNoParams };
					phone: { label: LocaleNoParams; placeholder: LocaleNoParams };
					wgacLabels: {
						email: { edit: LocaleNoParams; cancel: LocaleNoParams };
						phone: { edit: LocaleNoParams; cancel: LocaleNoParams };
					};
				};
				button: {
					next: { text: LocaleNoParams; ariaLabel: LocaleNoParams };
				};
			};
			step2: {
				label: LocaleNoParams;
				prijemce: { label: LocaleNoParams; value: LocaleNoParams };
				PPPSelect: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					required: LocaleNoParams;
					'podnet-k-doplneni-seznamu': LocaleNoParams;
				};
				missingPPP: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					'error-message': LocaleNoParams;
					sectionLabel: LocaleNoParams;
				};
				missingPPPOvm: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					'error-message': LocaleNoParams;
				};
				reasonForAddingMissingPPP: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					'error-message': LocaleNoParams;
				};
				pppOvmAutocomplete: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					required: LocaleNoParams;
				};
				isOVMDefunct: { label: LocaleNoParams };
				defunctAddress: {
					label: LocaleNoParams;
				};
				vydanyDokument: {
					label: LocaleNoParams;
				};
				defunctOVMName: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					'error-message': LocaleNoParams;
				};
				defunctOVMStreet: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					'error-message': LocaleNoParams;
				};
				defunctOVMCity: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					'error-message': LocaleNoParams;
				};
				defunctOVMPostalCode: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					'error-message': LocaleNoParams;
				};
				defunctOVMCityPart: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
				};
				defunctOVMDescriptiveNumber: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					'error-message': LocaleNoParams;
				};
				defunctOVMEvidenceNumber: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
				};
				defunctOVMOrientationNumber: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
				};
				number: { label: LocaleNoParams; placeholder: LocaleNoParams };
				issueDate: { label: LocaleNoParams };
				dateFrom: { label: LocaleNoParams };
				dateTo: { label: LocaleNoParams };
				fileUpload: { label: LocaleNoParams };
				message: LocaleNoParams;
				button: {
					next: { text: LocaleNoParams; ariaLabel: LocaleNoParams };
				};
			};
			step3: {
				label: LocaleNoParams;
				message: {
					nevybrano: LocaleNoParams;
					rekapitulace: {
						neuvedeno: LocaleNoParams;
					};
				};
				'moje-udaje': {
					title: LocaleNoParams;
					id: LocaleNoParams;
					wgacLabel: LocaleNoParams;
					label: LocaleNoParams;
					rekapitulace: {
						prijmeni: LocaleNoParams;
						jmeno: LocaleNoParams;
						'datum-narozeni': LocaleNoParams;
						'adresa-trvaleho-bydliste': LocaleNoParams;
						nazev: LocaleNoParams;
						ico: LocaleNoParams;
						'adresa-sidla': LocaleNoParams;
						'e-mail': LocaleNoParams;
						telefon: LocaleNoParams;
					};
				};
				'detail-zadosti': {
					title: LocaleNoParams;
					id: LocaleNoParams;
					wgacLabel: LocaleNoParams;
					label: LocaleNoParams;
					rekapitulace: {
						'typ-PPP': LocaleNoParams;
						'prislusne-OVM': LocaleNoParams;
						'vydany-dokument': LocaleNoParams;
						'cislo-dokumentu': LocaleNoParams;
						'datum-vydani': LocaleNoParams;
						'platnost-od-do': LocaleNoParams;
						priloha: LocaleNoParams;
					};
				};
				button: {
					submit: { text: LocaleNoParams; ariaLabel: LocaleNoParams };
				};
			};
		};
	};
};

export type PPPLocaleReturnType = LocaleDefinition<PPPLocales>;

export const usePPPLocale = (): PPPLocaleReturnType =>
	useLocale(ServiceCode['PPP']);
